import { CULTURAS } from './TipoCultura';
import L from 'leaflet';

export const COR_CAMADA_IMOVEL = '#FFEE3E';
const COR_CAMADA_ESTADO = 'white';
const COR_CAMADA_RESTRICAO = 'red';
export const COR_CAMADA_PLANTADA = '#9CCC65';
const COR_AREA_PLANTADA_MONITORADA = '#FFEE58';

export function getEstiloCultura(cultura) {
    return {
        color: cultura.cor,
        weight: 1,
        fill: true,
        fillColor: cultura.cor,
        fillOpacity: 0.7
    };
}

const LayerStyles = {
    ESTADO: () => {
        return {
            color: COR_CAMADA_ESTADO,
            weight: 1,
            fill: false
        };
    },

    MARKER: (codigoCultura, latlng) => {
        const codigo = codigoCultura || 'OUTROS';
        return new L.CircleMarker(latlng, {
            radius: 4,
            fill: true,
            fillColor: CULTURAS[codigo].cor,
            color: CULTURAS[codigo].cor,
            weight: 10,
            opacity: 0.3,
            fillOpacity: 1.0
        });
    },

    RESTRICAO: () => {
        return {
            color: COR_CAMADA_RESTRICAO,
            weight: 0.3,
            fill: true,
            fillColor: COR_CAMADA_RESTRICAO,
            fillOpacity: 0.4
        };
    },

    AREA_MONITORADA: () => {
        return {
            color: COR_CAMADA_IMOVEL,
            weight: 1,
            fill: true,
            fillOpacity: 0,
            dashArray: '5,5'
        };
    },

    AREA_PLANTADA: () => {
        return {
            color: COR_CAMADA_PLANTADA,
            weight: 2,
            fill: true,
            fillColor: COR_CAMADA_PLANTADA,
            fillOpacity: 0.4
        };
    },

    AREA_PLANTADA_MONITORADA: () => {
        return {
            color: COR_AREA_PLANTADA_MONITORADA,
            weight: 1,
            fill: true,
            fillColor: COR_AREA_PLANTADA_MONITORADA,
            fillOpacity: 0.3
        };
    },

    MILHO() {
        return getEstiloCultura(CULTURAS.MILHO);
    },

    SOJA() {
        return getEstiloCultura(CULTURAS.SOJA);
    },

    ALGODAO() {
        return getEstiloCultura(CULTURAS.ALGODAO);
    },

    OUTROS() {
        return getEstiloCultura(CULTURAS.OUTROS);
    },

    NAO_IDENTIFICADA() {
        return getEstiloCultura(CULTURAS.NAO_IDENTIFICADA);
    }
};

export default LayerStyles;
